import { ReactTooltipStyled } from "components/atoms/Tooltip/Tooltip.styled";
import { Small } from "utils/styling/typography.styled";
export const PremiumTooltip = () => {
  return <ReactTooltipStyled id="premiumTip" data-sentry-element="ReactTooltipStyled" data-sentry-component="PremiumTooltip" data-sentry-source-file="index.tsx">
            <ul>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Superior prompt adherence</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Higher image quality</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Enhanced detail and accuracy</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Realistic and vivid fantasy races</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">High-definition (HD) images</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Exclusive premium themes</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Latest AI models</Small>
                </li>
                <li>
                    <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">Earn free tokens by sharing on social media</Small>
                </li>
            </ul>
            <Small data-sentry-element="Small" data-sentry-source-file="index.tsx">
                Upgrade to Premium for the best image generation experience!
            </Small>
        </ReactTooltipStyled>;
};